import { useDevice } from '../store';

export function TopBar({ right }: { right?: React.ReactNode }) {
  const resetRole = useDevice((s) => s.resetRole);
  return (
    <div className="kbar">
      <div className="kbar-logo" onDoubleClick={resetRole} title="Double-clic : changer de rôle">
        TAJ FUSION
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        {right}
        <button className="linkbtn" onClick={resetRole}>
          ⚙︎ rôle
        </button>
      </div>
    </div>
  );
}
